import React, { useEffect, useRef, useState } from 'react'
import { NativeModules, Platform, ScrollView, Text, View } from 'react-native'
import { useDispatch } from 'react-redux';
import { sendAnalytics } from '../../../../Redux/Actions/analyticsAction';
import { CHECKIN_DEMO_FLOW, DEMO_FLOW_ENABLED, MOBILE_CHECKIN_CATEGORY } from '../../../../config/Constant';
import HeaderWithBack from '../../../../components/Header/headerWithBack';
import { useCssStyle } from '../../../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';
import { CustomTextInput } from '../../../../components/customTextInput';
import InfoPopupModal from '../../../../components/infoPopupModal';
import FetchingDataScreen from '../../../../components/fetchingDataScreen';
import { setRenderFlashMessage } from '../../../../Redux/Actions/appConfigAction';
import { cardValidation } from '../../../../Redux/Actions/checkInAction';
import CustomPressable from '../../../../components/customPressable/customPressable';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { isIOS, isWeb, sendMessageToFrame } from '../../../../utils/Helper';
import Loader from '../../../../components/Loader/loader';
import WebView from 'react-native-webview';

const Shift4 = ({checkinSessionToken, guestValidationMaxRetry, guestDetails, isCardVerified, handleSetCardVerified, handleGoBack, handleCustomCancelClick, handleNext, handleSkip }) => {

    const dispatch = useDispatch();
    const getStyles = useCssStyle();
    const { t } = useTranslation();
    

    let shift4_InitURL = "https://guest-journey.s3.amazonaws.com/static/Shift4i4go.html";

    const [webviewLoading, setWebviewLoading] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    
    

    const webViewRef = useRef(null);

    const [loaderState, setLoaderState] = useState({
        isVisible: false,
        message: ""
    });
    const [errorState, setErrorState] = useState({
        errorStatus: false,
        errorMessage: ""
    });
    const [cardModalStatus, setCardModalStatus] = useState({
        enableCardModal: false,
        sessionUrl: ""
    });

    const [isAvsEnable, setIsAvsEnable] = useState(false);


    const [localGuestDetails, setLocalGuestDetails] = useState(() => ({
        firstName: guestDetails?.firstName || "",
        lastName: guestDetails?.lastName || "",
        address: {
            addressLine1: guestDetails?.address?.addressLine1 || "",
            postalCode: guestDetails?.address?.postalCode || "",
        }
    }));

    const updateLoaderState = (state, msg) => {
        if (state) {
            setLoaderState({ isVisible: true, message: msg });
        } else {
            setLoaderState({ isVisible: false, message: "" });
        }
    }

    const updateCardModalStatus = (status, url) => {
        if (status) {
            setWebviewLoading(true);
            setCardModalStatus({ enableCardModal: true, sessionUrl: url });
        } else {
            setCardModalStatus({ enableCardModal: false, sessionUrl: "" });
        }
    }

    const updateErrorState = (state, msg) => {
        if (state) {
            setErrorState({ errorStatus: true, errorMessage: msg });
        } else {
            setErrorState({ errorStatus: false, errorMessage: "" });
        }
    }

    const initiateCardValidation = async () => {
        updateErrorState(false, "");
        updateLoaderState(true, "Preparing card info container...")


        const cardValidationRegisterPayload = {
            "confirmationNumber": guestDetails.confirmationNumber,
        }

        const { success, data, message } = await cardValidation("register", cardValidationRegisterPayload);

        updateLoaderState(false);

        if (success) {
            setIsAvsEnable(data?.isAvsEnable);
            let cardModalUrl = `${shift4_InitURL}?accessblock=${data.accessBlock}&server=${data.server}&isDemo=${(DEMO_FLOW_ENABLED || CHECKIN_DEMO_FLOW) ? "true" : "false"}`
            updateCardModalStatus(true, cardModalUrl)
        } else {
            updateErrorState(true, message || "Something went wrong");
            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": message || "Error during card validation: register" }));
        }

    };

    const splitFirstandLastName =(fullName)=>{
        const trimmedFullName= fullName.trim();
        const indexToBreak= trimmedFullName.indexOf(" ");
        if(indexToBreak>0){
            return [trimmedFullName.slice(0,indexToBreak), trimmedFullName.slice(indexToBreak+1)];
        }else{
            return [trimmedFullName,""];
        }
    }

    const handleCardValidationSuccess = async (response) => {

        updateCardModalStatus(false);
        updateLoaderState(true, "Validating card info...")

        const cardValidationPayload = {
            "confirmationNumber": guestDetails.confirmationNumber,
            "cardDigits": response.i4go_maskedcard.slice(12, 17),
            "cardCheckId": response.i4go_uniqueid,
            "cardFullName": response.i4go_cardholdername,
            "lastNameCard": splitFirstandLastName(response.i4go_cardholdername)[1],
            ...(isAvsEnable && {
                isAvsValid: response.paymentAPIResults?.CARD_VERIFY?.transaction?.avs?.valid == 'Y'
            })
        }

        const checkingCardInfoAsPerBooking = await cardValidation("checks", cardValidationPayload);
        let room = await AsyncStorage.getItem('room');

        if (checkingCardInfoAsPerBooking.success) {
            updateLoaderState(true, "Updating card details for the booking...");

            if(isAvsEnable && response.paymentAPIResults?.CARD_VERIFY?.transaction?.avs?.valid == 'Y'){

                dispatch(sendAnalytics(
                    MOBILE_CHECKIN_CATEGORY, 
                    "AVS - SUCCESS", 
                    {   dateTime: new Date, 
                        pageName: "CREDIT CARD DETAILS",
                        Room: room || "", 
                        element: "widget", 
                        widgetSessionId: checkinSessionToken,
                        sourceApp: "guestJourneyApp",
                        cardHolderName: response.i4go_cardholdername,
                        cardDigits: response.i4go_maskedcard,
                        expirationMonth: response.i4go_expirationmonth,
                        expirationYear: response.i4go_expirationyear
                    }
                ));
            }

            const cardUpdatePayload = {
                ...cardValidationPayload,
                vaultedCardId: response.i4go_uniqueid,
                cardTypeCode: isAvsEnable ? (response.paymentAPIResults && response.paymentAPIResults.CARD_VERIFY.card.type) || ""
                    : (response.paymentAPI ? response.paymentAPI.card.type : response.i4go_cardtype || ""),
                expiryDate: response.i4go_expirationmonth + (response.i4go_expirationyear).slice(2, 4),
                firstNameCard: splitFirstandLastName(response.i4go_cardholdername)[0],
                lastNameCard: splitFirstandLastName(response.i4go_cardholdername)[1],
            }

            const updateCardInfo = await cardValidation("cardUpdate", cardUpdatePayload);
            updateLoaderState(false);

            if (updateCardInfo.success) {
                console.log("card validation successfull");
                handleSetCardVerified(true);
                dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS - SUCCESS", { "element": "widget", "widgetSessionId": checkinSessionToken }));
            } else {
                updateErrorState(true, updateCardInfo.message || "Something went wrong");
                dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": updateCardInfo.message || "Error during card validation: cardUpdate" }));
            }

        } else {
            updateLoaderState(false);

            let errorReason = null;
            if (isAvsEnable && response.paymentAPIResults?.CARD_VERIFY?.transaction?.avs?.valid == 'Y') {

                const avsResultCode = response.paymentAPIResults.CARD_VERIFY.transaction.avs.result;
                errorReason = t(`check_in.card_validation.shift4.${avsResultCode}`) || 'Unknown AVS failure.';

                dispatch(sendAnalytics(
                    MOBILE_CHECKIN_CATEGORY, 
                    "AVS - Failed", 
                    { 
                        dateTime: new Date,
                        pageName: "CREDIT CARD DETAILS",
                        widgetSessionId: checkinSessionToken,
                        Room: room || "",
                        sourceApp: "guestJourneyApp",
                        errorReason: errorReason,
                        avsResultCode: avsResultCode,
                        cardHolderName: response.i4go_cardholdername,
                        cardDigits: response.i4go_maskedcard,
                        expirationMonth: response.i4go_expirationmonth,
                        expirationYear: response.i4go_expirationyear
                    }
                ));
            } else{
                dispatch(sendAnalytics(
                    MOBILE_CHECKIN_CATEGORY, 
                    "CREDIT CARD DETAILS - FAILED", 
                    { 
                        "element": "widget", 
                        "widgetSessionId": checkinSessionToken, 
                        "errorMessage": checkingCardInfoAsPerBooking.message || "Error during card validation: checks" 
                    }
                ));
            }
            if(errorReason){
                updateErrorState(true, `Card verification failed: ${errorReason} Please check your billing address or contact the Front Desk for assistance.`);
            }else{
                updateErrorState(true, checkingCardInfoAsPerBooking.message || "Something went wrong");
            }
        }
    }

    const handleCardValidationError = (errorMessage) => {
        // updateCardModalStatus(false)
        updateErrorState(true, errorMessage || "Something went wrong");
    }

    const handleClose = () => {
        handleGoBack();
    }


    const handleOnMessageReceive = (event) => {
        setIsProcessing(false)
        try {

            if(isWeb() && !shift4_InitURL.includes(event.origin)) {
                return;
            }

            const message = isWeb() ? JSON.parse(event.data) : JSON.parse(event.nativeEvent.data);

            console.log('Received message from Shift4:', message);
            
            if (message.status == "SUCCESS") {
                handleCardValidationSuccess(message.data)
                return;
            }
            if (message.status == "FAILURE") {
                handleCardValidationError(message.data?.error || message.data?.i4go_responsetext || "Something went wrong");
                dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": message.data?.error || message.data?.i4go_responsetext}));
                return;
            }
        } catch (error) {
            console.log('Error in onMessage:', error);
            handleCardValidationError(error?.message || "Something went wrong");
            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": error?.message || "Error during card validation" }));
        }
    };


    const confirmCardWithShift4 = () =>{
        setIsProcessing(true);

        if (webViewRef.current) {
             sendMessageToFrame(webViewRef, "submitClicked");
        } else {
            updateErrorState(true, "Something went wrong");
        }
    }



    // Add event listener for web platform
    useEffect(() => {
        dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS", { "element": "widget", "widgetSessionId": checkinSessionToken}));
        if (!isCardVerified) initiateCardValidation();

        if (isWeb()) {
            window.addEventListener("message", handleOnMessageReceive);
        }

        return () => {
            if (isWeb()) {
                window.removeEventListener("message", handleOnMessageReceive);
            }
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <View style={getStyles(['widgetRootContainer', 'cardValidationRootContainer'])} showsVerticalScrollIndicator={0}>
            <HeaderWithBack handleCustomBackPress={handleGoBack} handleCustomCancelClick={handleCustomCancelClick} />

            <ScrollView automaticallyAdjustKeyboardInsets={true} contentContainerStyle={getStyles(['widgetmainContainer', 'cardValidationMainContainer'])} showsVerticalScrollIndicator={false}>

                <View style={getStyles(['widgetmainContainerHeaderContainer', 'cardValidationHeaderContainer'])}>
                    <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'cardValidationHeaderTitleContainer'])}>
                        <Text style={getStyles(['widgetmainContainerHeaderTitle', 'cardValidationHeaderTitle'])}>{t('check_in.card_validation.heading')}</Text>
                        {t('check_in.card_validation.sub_heading') && <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'cardValidationHeaderSubTitle'])}>{t('check_in.card_validation.sub_heading')}</Text>}
                    </View>
                </View>

                <View style={getStyles(['widgetmainContainerChildContainer', 'cardValidationMainContainerChildContainer'])}>
                    {cardModalStatus.enableCardModal &&
                        <View style={getStyles(['shift4CardContainer'])}>
                            {webviewLoading && (
                                <View style={{ height: "100%", justifyContent: "center", alignItems: "center" }}>
                                    <Loader style={getStyles(['crossOverContaniner_loader'])} />
                                </View>
                            )}
                            {isWeb() ? (
                                <iframe
                                    ref={webViewRef}
                                    src={cardModalStatus.sessionUrl}
                                    style={getStyles(['shift4CardContainer_iframe'])}
                                    title="shift4"
                                    onLoad={() => setWebviewLoading(false)}
                                />
                            ) : (
                                <WebView
                                    ref={webViewRef}
                                    style={getStyles(['shift4CardContainer_webview'])}
                                    originWhitelist={['*']}
                                    source={{ uri: cardModalStatus.sessionUrl }}
                                    onMessage={handleOnMessageReceive}
                                    showsVerticalScrollIndicator={false}
                                    javaScriptEnabled={true}
                                    onError={(error) => console.log(error)}
                                    webviewDebuggingEnabled={true}
                                    pullToRefreshEnabled={false}
                                    cacheEnabled={false}
                                    onLoad={() => setWebviewLoading(false)}
                                />
                            )}
                        </View>
                    }
                    <View style={getStyles(['cardValidationChildContainer_buttonContainer'])}>
                        <CustomPressable style={getStyles(['primaryBtn'])} onPress={confirmCardWithShift4} disabled={!cardModalStatus.enableCardModal || webviewLoading || isProcessing}>
                            <Text style={getStyles(['primaryBtnTxt'])}>{t('check_in.card_validation.submit')}</Text>
                        </CustomPressable>
                        {DEMO_FLOW_ENABLED &&
                            <CustomPressable style={getStyles(['secondaryBtn'])} onPress={handleSkip}>
                                <Text style={getStyles(['secondaryBtnTxt'])}>{t('check_in.card_validation.skip')}</Text>
                            </CustomPressable>
                        }
                    </View>
                </View>
            </ScrollView>

            { isCardVerified &&
                <InfoPopupModal
                    type={"success"}
                    title={"Card Verified!"}
                    subtitle={"Your card was successfully verified."}
                    onContinue={() => handleNext(localGuestDetails)}
                    primaryBtnLabel={"Next"}
                />
            }


            {loaderState.isVisible && <FetchingDataScreen loaderMessage={loaderState.message} />}
            
            {errorState.errorStatus && 
                <InfoPopupModal 
                    subtitle={errorState.errorMessage} 
                    onClose={() => handleClose()} 
                    secondaryBtnLabel={"Close"} 
                    onContinue={initiateCardValidation}
                    primaryBtnLabel={t('check_in.card_validation.retry')}
                    disablePrimaryBtn={loaderState.isVisible}
                />
            }
        </View>
    )
}

export default Shift4
